import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import SINGLE_TOOLBAR_MENU_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolmenu_outline_light_24.svg';

export const config = {
    id: ActionType.SINGLE_TOOLBAR_MENU,
    tipMsg: i18n.t('菜单'),
    title: i18n.t('菜单'),
    icon: SINGLE_TOOLBAR_MENU_ICON,
};

export const VIP_MENU = 'vip-menu-parent';

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        // 这张资源图有问题，没有尺寸
        icon: <img src={config.icon} alt={''} style={{
            width: 20,
            height: 20,
        }}/>,
        text: config.title,
        tooltip: config.tipMsg,
        style: {
            width: 'auto',
        },
    },
];

export const vipMenuConfig = {
    name: VIP_MENU,
    content: i18n.t<string>('会员专享'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: '',
    },
    {
        name: `${ActionType.INSERT_ALL}-menu-parent`,
        content: i18n.t<string>('插入'),
    },
    {
        name: 'play-menu-parent',
        content: i18n.t<string>('放映'),
    },
    vipMenuConfig,
];
